import { NavigationButton } from '../../generic/Button';
import Flex from '../../generic/Flex';
import FOSSALogoWithCat from '../../generic/FOSSALogoWithCat';
import Link from '../../generic/Link';
import { window } from '../../../globals';

type AuthHeaderProps = {
  showHomePageBtn?: boolean;
};

/**
 * Header for the authentication pages.
 * Contains the logo & optionally a link back to the homepage.
 *
 * @param {boolean} showHomePageBtn - If we should also display the home page button.
 */
const Header = ({ showHomePageBtn }: AuthHeaderProps) => (
  <header className="fossa-auth__header">
    <Flex justify="space-between" className="fossa-auth__header__content">
      <Link to="https://fossa.com/" openInNewTab>
        <FOSSALogoWithCat width={140} />
      </Link>
      {showHomePageBtn && (
        <NavigationButton
          size="x-large"
          to="https://fossa.com/"
          openInNewTab
        >
          Go to Homepage
        </NavigationButton>
      )}
      {/*
        If the user is logged in but hasn't created/joined an org, they will be on the AuthOnboarding,
        and should be able to log out as an "escape hatch":
      */}
      {!showHomePageBtn && (window.user && !window.user.organization) && (
        <NavigationButton
          size="x-large"
          to={`${window.location.origin}/account/logout`}
        >
          Logout
        </NavigationButton>
      )}
    </Flex>
  </header>
);

export default Header;
